<template>
  <v-toolbar color="primary" fixed dark app>
    <v-toolbar-title class="ml-0 pl-3"> </v-toolbar-title>
    <v-toolbar-side-icon
      v-if="adminPermision"
      @click.stop="handleDrawerToggle"
    ></v-toolbar-side-icon>
    <v-btn v-if="!adminPermision" @click.stop="defaultView()" icon>
      <v-icon class="fa-2x">library_books</v-icon>
    </v-btn>
    <!-- <v-text-field
      flat
      solo-inverted
      prepend-icon="search"
      label="Search"
      class="hidden-sm-and-down"
    >
    </v-text-field> -->
    <v-spacer></v-spacer>
    <!-- <v-toolbar-items>
      <v-btn flat href="mailto:wangqiangshen@gmail.com">
        Hire Me
      </v-btn>
    </v-toolbar-items> -->
    <v-btn v-if="adminPermision" icon @click="handleEmergency">
      <v-icon class="fa-2x" style="color: orange">fa-users</v-icon>
    </v-btn>
    <v-btn v-if="adminPermision" icon @click="handleSignIn">
      <v-icon class="fa-2x">fa-sign-in</v-icon>
    </v-btn>
    <v-btn v-if="adminPermision" icon @click="handleSignOut">
      <v-icon class="fa-2x">fa-sign-out</v-icon>
    </v-btn>
    <!-- <v-menu
      offset-y
      origin="center center"
      class="elelvation-1"
      :nudge-bottom="14"
      transition="scale-transition"
    >
      <v-btn icon flat slot="activator">
        <v-badge color="red" overlap>
          <span slot="badge">3</span>
          <v-icon medium>notifications</v-icon>
        </v-badge>
      </v-btn>
      <notification-list></notification-list>
    </v-menu> -->
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
    >
      <v-btn icon large flat slot="activator">
        <v-icon v-if="!profileURL">person</v-icon>
        <v-avatar v-if="profileURL" size="30px">
          <img :src="profileURL" alt="Michael Wang" />
        </v-avatar>
      </v-btn>
      <v-list class="pa-0">
        <v-list-tile
          v-for="(item, index) in items"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-tile-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-btn icon @click="handleFullScreen()">
      <v-icon>fullscreen</v-icon>
    </v-btn>
  </v-toolbar>
</template>
<script>
// import NotificationList from "@/components/widgets/list/NotificationList";
import Util from "@/util";
import Helpers from "@/mixins/helpers";
export default {
  name: "app-toolbar",
  components: {
    // NotificationList
  },
  mixins: [Helpers],
  data() {
    return {
      items: [
        {
          icon: "account_circle",
          href: "#",
          title: "Profile",
          click: e => {
            console.log(e);
            window.getApp.$emit("APP_PROFILE");
          }
        },
        {
          icon: "account_circle",
          href: "#",
          title: "Company",
          click: e => {
            console.log(e);
            window.getApp.$emit("APP_COMPANY");
          }
        },
        {
          icon: "fullscreen_exit",
          href: "#",
          title: "Logout",
          click: e => {
            console.log(e);
            this.handleLogout(e);
          }
        }
      ]
    };
  },
  created() {
    this.refreshPoliciesList();
    if (this.adminPermision === false) {
      this.items = [this.items[0], this.items[2]];
    }
  },
  computed: {
    adminPermision: function() {
      if (localStorage.active_user == null) {
        return true;
      }
      let object = JSON.parse(localStorage.active_user);
      if (object.role === 6) {
        return false;
      }
      return true;
    },
    profileURL: function() {
      if (this.user && this.user.avatar) {
        return this.baseURL + "/" + this.user.avatar;
      }
      return null;
    },
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
    loginUser() {
      let user = localStorage.getItem("active_user");
      let activeUser = JSON.parse(user);
      return activeUser.avatar;
    }
  },
  methods: {
    refreshPoliciesList: async function() {
      try {
        let policies = await this.getPolicies();
        this.$store.commit("applyPolicies", policies);
      } catch (error) {
        this.$toast.error("Cannot get details!", "Error", {
          position: "topCenter"
        });
      }
    },
    handleLogout: function() {
      if (this.user.role === 1) {
        this.$swal({
          title: "Logout",
          text: "Do you want to logout?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true
        }).then(result => {
          console.log(result);
          if (result["dismiss"] === "cancel") {
            console.log("dismissed");
          } else {
            window.getApp.$emit("APP_LOGOUT");
            this.$cookies.remove("server", localStorage.port);
            // window.getApp.$emit("APP_LOGOUT");
            this.$store.commit("resetState");
          }
        });
      } else {
        this.$cookies.remove("server", localStorage.port);
        window.getApp.$emit("APP_LOGOUT");
      }
    },
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleSignIn() {
      window.getApp.$emit("APP_SIGN_IN");
    },
    handleEmergency() {
      window.getApp.$emit("APP_SIGN_EMERGENCY");
    },
    handleSignOut() {
      window.getApp.$emit("APP_SIGN_OUT");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    },
    defaultView() {
      this.$router.push("/resources");
    }
  }
};
</script>
